import { ContentControlledEditingDirective } from '../editing-directive';
import ContentControlStudioOperation from "./content-control-studio-operation";

export default class ContentControlStudioRemoveEventOperation extends ContentControlStudioOperation {
  constructor(
    public event: ContentControlledEditingDirective,
    public events: Array<ContentControlledEditingDirective>,
    callback?,
  ) {
    super(
      () => {
        const index = events.findIndex((x) => x.id == event.id);
        if (index > -1) {
          events.splice(index, 1);
        }
      },
      () => {
        if (events.findIndex((x) => x.id == event.id) == -1) {
          events.push(event);
        }
      },
      callback,
    );
  }
}
